module.exports = __webpack_public_path__ + "static/media/imgGalleryM2.a8349097.svg";